export default {
  gameLobby: "เกมล็อบบี้",
  account: "ID",
  balance: "ยอดเงิน",
  searchGame: "ค้นหาเกม",
  gameSearch: "ค้นหาเกม",
  myFollowedGames: "เกมโปรด",
  allGames: "ทั้งหมด",
  like: "เกมที่ฉันติดตาม",
  new: "ใหม่",
  hot: "ยอดนิยม",
  reco: "แนะนำ",
  enterGame: "เข้าสู่เกม",
  searchText: `ผลการค้นหาเกี่ยวกับ <0>{{searchValue}}</0> มีดังนี้:`,
  goToHotGames: "กลับไป เกมยอดนิยม",
  soEmpty: "โอ๊ะ~ว่างเปล่า",
  cantFindGame: "ไม่พบเกมที่สอดคล้องกัน",
  noGameCanPlay: "อุ๊บส์ ~ ไม่มีเกมให้เล่น",
  cantFindPage: "ไม่พบข้อมูลในหน้านี้",
  sorryPageRunAway: "ขออภัย ไม่พบหน้าที่ท่านกำลังหาอยู่",
  backToHome: "กลับไป หน้าหลัก",
  authFail: "การยืนยันไม่ถูกต้อง",
  goWrong: "การยืนยันบัญชีไม่ถูกต้อง โปรดปิดหน้า",
  maintain: "อยู่ในระหว่างการปรับปรุง",
  annoucement: "ประกาศทั่วไป",
  websiteMaintenance: "เว็บไซต์อยู่ในระหว่างการปรับปรุง",
  systemMaintain: "กำลังอัพเกรดปรับปรุงระบบ โปรดลองใหม่ภายหลัง!",
  recentPlayed: "เกมที่เพิ่งเล่น",
  send: "นำออก",
  payoutRank: "ดัชนีการจ่าย",
  playerRank: "อันดับผู้เล่น",
  rank: "ลำดับ",
  recommend: "ฟีเจอร์เกม",
  idRound: "ID/เลขสั่งซื้อ",
  payout: `ยอดเงินที่จ่าย <span class="highlight">(¥)</span>`,
  payoutInfo: {
    title: "อัพเดททุกชั่วโมง",
    content: [
      `เมื่อดัชนีการจ่าย > 0 แสดงว่าการจ่ายในชั่วโมงก่อนหน้า <span class="highlight">สูงกว่า</span> ค่าทฤษฎี`,
      `เมื่อดัชนีการจ่าย < 0 แสดงว่าการจ่ายในชั่วโมงก่อนหน้า <span class="highlight">ต่ำกว่า</span> ค่าทฤษฎี`,
    ],
  },
  playerInfo: {
    title: "อันดับยอดนิยมใน 30 วัน",
    content: [`อันดับโดยรวมขึ้นอยู่กับจำนวนเงินที่จ่ายของผู้เล่นจากมากไปน้อย`],
  },
  newToOld:"ใหม่ → เก่า",
  oldToNew:"เก่า → ใหม่",
  favorite: "ติดตาม",
}